import { z } from 'zod';

export const CreateStockAdjustmentSchema = z.object({
    items: z.array(
        z.object({
            purchaseItemId: z.string(),
            productVariationId: z.string(),
            quantity: z.coerce.number().optional(),
        }),
    ),
    note: z.string().nonempty({ message: 'Note is required' }),
});

export type CreateStockAdjustment = z.infer<typeof CreateStockAdjustmentSchema>;
